import { useMemo } from "react";

import { useListAvailableTemplatedInstructions } from "@api/rest/types-and-hooks";
import { PromptKeyedLookupSelect } from "@pages/Prompts/PromptKeyedLookupSelect";

interface PromptTemplatedInstructionsSelectProps {
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
}

/** Templated-instructions picker — pipelines'
 *  ``prompts/templated_instructions/*.yaml`` catalog only. NO custom
 *  fallback here (unlike role/technical_instructions): an unknown key
 *  now rejects the PR outright rather than silently resolving to
 *  ``None`` (see ``_resolved_templated_instructions`` /
 *  ``_resolve_templated``), and there's no auto-registration path for
 *  this field the way there is for role — a non-UI caller (Rio/M2M)
 *  sending free-form text here gets a clear error, not a silent no-op.
 *  Users pick from the catalog or leave blank. */
export const PromptTemplatedInstructionsSelect: React.FC<PromptTemplatedInstructionsSelectProps> = ({
  value,
  onChange,
  disabled,
}) => {
  const { data, isLoading } = useListAvailableTemplatedInstructions();
  const items = useMemo(() => (data?.status === 200 ? data.data.items : []), [data]);
  return (
    <PromptKeyedLookupSelect
      value={value}
      onChange={onChange}
      items={items}
      isLoading={isLoading}
      disabled={disabled}
      allowCustom={false}
    />
  );
};
